import { Button, CircularProgress, TextField } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { CERTIFICATES } from "./CertificateHtmls";
import { BANNERS } from "./BannerHtmls";
import './css/free_generator.css';
import { FreeGeneratorPreview } from "./FreeGeneratorPreview";
const fields = {
    'certificate': [{
        'label': 'Name',
        'value': '',
        placeholder: 'John Doe'
    },
    {
        'label': 'Date',
        'value': '',
        placeholder: 'March 30th, 2025'
    },
    {
        'label': 'Description',
        'value': '',
        placeholder: 'For completing the course on Web Development'
    }, {    
        'label': 'Signature',
        'value': '',
        placeholder: 'Dr. Richard Smith'
    }
], 'linkedin-banner': [{
        'type': 'image',
        'label': 'Profile Picture',
        'key': 'profile_pic',
        'value': '',
        'placeholder': 'Upload a profile picture'
    }, {
        'label': 'Logo',
        'key': 'profile_logo',
        'type': 'image',
        'value': '',
        'placeholder': 'Upload a logo'
    }, {
        'label': 'Name',
        'key': 'profile_name',
        'value': '',
        placeholder: 'John Doe'
    },
    {
        'label': 'Description',
        'key': 'profile_description',
        'value': '',
        placeholder: 'Software Engineer at Google'
    },
    {
        'label': 'Phone',
        'key': 'profile_phone',
        'value': '',
        placeholder: '+1 234 567 8900'
    },
    {
        'label': 'Email',
        'key': 'profile_email',
        'value': '',
        placeholder: 'john.doe@gmail.com'
    }, {
        'label': 'Website',
        'key': 'profile_website',
        'value': '',
        placeholder: 'https://www.johndoe.com'
    }, {
        'label': 'Address',
        'key': 'profile_address',
        'value': '',
        placeholder: '123 Main St, San Francisco, CA 94101'
    }
]}

export function FreeGenerator({generatorType}) {
    const htmls = generatorType === 'certificate' ? CERTIFICATES : BANNERS;
    const [html, setHtml] = useState(null);
    const [values, setValues] = useState({});
    const [selectedTemplate, setSelectedTemplate] = useState(0);
    const iframeRef = useRef(null);
    const [loading, setLoading] = useState(false);

    function generate(html, values) {
        for (let k in values) {
            html = html.replace(`{${k.toLowerCase()}}`, values[k]);
        }
        for (let k in fields[generatorType]) {
            if (!values[k]) {
                html = html.replace(`{${k.toLowerCase()}}`, '');
            }
        }        

        html = html.replace('</head>', `
        <script src="https://mmb-js.s3.us-east-1.amazonaws.com/dom-to-image-new.js"></script>
        <style>
        
        </style>
        <script>
            function screenshot() {
                domtoimage.toPng(document.body).then((dataUrl) => {
                    var link = document.createElement('a');
                    link.download = 'makemybrand-infographic.png';
                    link.href = dataUrl;
                    link.click();
                }).catch(e => {
                    console.error(e);
                });
            }
        </script>
        </head>

        `);

        setHtml(html);
    }

    function download() {
        setLoading(true);
        let originalHtml = html;
        let newHtml = html.replace('</head>', `
            <script>
            document.addEventListener('DOMContentLoaded', async function screenshotWrapper() {
                setTimeout(async () => {
                    await screenshot();
                    document.removeEventListener('DOMContentLoaded', screenshotWrapper);
                }, 1000);
            });
            </script>
        </head>`);
        setHtml(newHtml);

        setTimeout(() => {
            setLoading(false);
            setTimeout(() => {
                setHtml(originalHtml);
            }, 1000)
        }, 2000);
    }

    function onIframeLoad() {
        const iframe = iframeRef.current;
        iframe.height = Math.ceil(iframe.contentWindow.document.body.scrollHeight) + "px";
    }

    if (html) {
        return (
            
        <div style={{
            position: "relative",
        }}>
            {loading && 
                <div style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: 2,
                    backgroundColor: "rgba(255, 255, 255, 0.8)",

                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}>
                    <CircularProgress />
                </div>
            }

            <div style={{
                display: "flex",
                flexDirection: "row",
                gap: 20,
                justifyContent: "center",
                alignItems: "center",
                marginTop: 20,
                marginBottom: 30
            }}>
                <Button size="large" variant="outlined" onClick={() => setHtml(null)} style={{
                    padding: "1rem 3rem",
                    fontSize: "1.5rem"
                }}>Edit</Button>
                <Button size="large" variant="contained" onClick={download} style={{
                    padding: "1rem 3rem",
                    fontSize: "1.5rem"
                }}>Download PDF</Button>
            </div>
            <div style={{
                display: "flex",
                flexDirection: "column",
                gap: 20,
                justifyContent: "center",
                alignItems: "center",
            }}>
                <iframe ref={iframeRef} srcDoc={html} style={{
                    width: "80%",
                    margin: "auto",
                    boxSizing: "content-box",
                    // height: 600 * 816 / 1056,
                }} onLoad={onIframeLoad} />
            </div>
        </div>);
    }
    return (
        <SelectTemplate generate={generate} values={values} setValues={setValues} selectedTemplate={selectedTemplate} setSelectedTemplate={setSelectedTemplate} fields={fields[generatorType]} htmls={htmls} generatorType={generatorType}/>
    )

}

export function SelectTemplate({generate, values, setValues, selectedTemplate, setSelectedTemplate, fields, htmls, generatorType}) {
    let w, h;
    if (generatorType === 'certificate') {
        // 1056 x 816 is the size of the certificate
        w = 200;
        h = w * 816 / 1056;
    } else {
        w = 1584;
        h = 396;
    }

    return (
        <div style={{
            textAlign: "center",
            maxWidth: 800,
            margin: "0 auto",
            padding: 20
        }}>
            <FreeGeneratorPreview generatorType={generatorType} />

            <div style={{
                display: "flex",
                flexDirection: "row",
                gap: 20,
                flexWrap: "wrap",
                justifyContent: "center",
                alignItems: "center",

                margin: "20px auto"
            }}>
                {htmls.map((cert, i) => (
                    <div key={i} >
                        <img src={cert.preview} style={{
                            width: "100%",
                            cursor: "pointer",
                            objectFit: "contain",
                            border: selectedTemplate === i ? "2px solid purple" : "2px solid transparent"
                        }} onClick={() => {
                            setSelectedTemplate(i);
                        }}/>
                    </div>
                ))}
            </div>
            <div style={{
                display: "flex",
                flexDirection: "column",
                gap: 20,
                justifyContent: "start",
                alignItems: "stretch",
                margin: "40px auto",
                width: 400,
            }}>
                {fields.map((field, i) => (
                    <div key={i} style={{
                    }}>
                        {field.type == "image" && (
                            <ImageUploader field={field} values={values} setValues={setValues}/>
                        )}
                        {field.type !== "image" && (
                            <TextField fullWidth label={field.label} value={
                                values[field.key]
                            } 
                            placeholder={field.placeholder}
                            onChange={(e) => {
                                setValues({
                                    ...values,
                                    [field.key]: e.target.value
                                })
                            }}/>
                        )}
                    </div>
                ))}
                <Button variant="contained" sx={{ mt: 2 }} fullWidth onClick={() => {
                    generate(htmls[selectedTemplate].html, values);

                }}>Download {generatorType === 'certificate' ? 'Certificate' : 'LinkedIn Banner'}</Button>
            </div>
            <div style={{
                fontSize: "0.9rem",
                marginTop: 40,
                marginBottom: 20,
                color: "grey"
            }}>
            Email us at support@makemybrand.ai to request features or report bugs.
            </div>

        </div>
    )
}

function ImageUploader({field, values, setValues}) {
    return (
        <>
            <span>{field.label}: </span>
            <input type="file" accept="image/*" onChange={(e) => {
                // convert to base 64
                const reader = new FileReader();
                reader.onload = () => {
                    setValues({
                        ...values,
                        [field.key]: reader.result
                    })
                }
                reader.readAsDataURL(e.target.files[0]);

            }}/>
        </>
    )
}